module.exports = __webpack_public_path__ + "static/img/company_logo.3720136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/company_logo.png
// module id = CjxS
// module chunks = 0